if (process.env.NODE_ENV === 'production') {
  module.exports = require('./grid.production.js');
} else {
  module.exports = require('./grid.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/grid/dist/es/grid.js
// module id = 175
// module chunks = 0